import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ParentMenuItem extends Component {
  render() {
    return (
      <div style={{marginTop: '20px', marginBottom: '10px'}}>
        <span className="title" style={{color: '#FFF', paddingLeft: '15px'}}>{this.props.title}</span>
      </div>
    );
  }
}

ParentMenuItem.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
};
ParentMenuItem.defaultProps = {};

export default ParentMenuItem;
